import { SortingOrder, TradeDataWithKey } from "@shared/types";
import {
  sortByNumberProperty,
  sortByStringProperty,
} from "@shared/utils/general.ts";

export enum TradesCardsSortKey {
  TIME = "time",
  SYMBOL = "symbol",
  AMOUNT = "amount",
  PNL = "pnl",
}

const OPEN_TIME_PATH = "timestamp";
const CLOSED_TIME_PATHS = ["close_timestamp", "timestamp"];
const AMOUNT_PATH = "allocated_amount_usd";
const PNL_PATH = "graph_data.profit";
const SYMBOL_PATH = "symbol";

const getNumberPath = (sortKey: TradesCardsSortKey, isOpenTrades: boolean) => {
  if (sortKey === TradesCardsSortKey.AMOUNT) return AMOUNT_PATH;
  if (sortKey === TradesCardsSortKey.PNL) return PNL_PATH;
  return isOpenTrades ? OPEN_TIME_PATH : CLOSED_TIME_PATHS;
};

export const compareTrades = (
  first: TradeDataWithKey,
  second: TradeDataWithKey,
  sortKey: TradesCardsSortKey,
  isOpenTrades: boolean,
  sortOrder: SortingOrder = SortingOrder.ASCEND
) =>
  sortKey === TradesCardsSortKey.SYMBOL
    ? sortByStringProperty(first, second, SYMBOL_PATH, sortOrder)
    : sortByNumberProperty(
        first,
        second,
        getNumberPath(sortKey, isOpenTrades),
        sortOrder
      );

export const sortTradesCards = (
  trades: TradeDataWithKey[],
  sortKey: TradesCardsSortKey,
  sortOrder: SortingOrder,
  isOpenTrades: boolean
) =>
  [...trades].sort((first, second) =>
    compareTrades(first, second, sortKey, isOpenTrades, sortOrder)
  );
